
import { WorldCountry } from '../types';
import { southAfricaExpanded3 } from './southAfricaExpansion3';
import { nigeriaExpanded3 } from './nigeriaExpansion3';
import { moroccoExpanded2 } from './moroccoExpansion2';
import { egyptExpanded } from './egyptExpansion';

// Expansión Fase 9 - Países de África con 100+ ciudades
export const africaExpansion4: WorldCountry[] = [
  southAfricaExpanded3,
  nigeriaExpanded3,
  moroccoExpanded2,
  egyptExpanded
];
